import { gql } from '@apollo/client'

import { TotalOfItems } from './types'

export type GetL1Names = TotalOfItems & {
  balance: {
    updatedAt: string
    token: {
      nativeId: string
    }
  }[]
}

export const QUERY_GET_L1_NAMES = gql`
  query GetL1Names($queryId: String!, $collectionId: String!) {
    balance(
      where: {
        _and: [{ token: { collection_id: { _eq: $collectionId } } }, { account: { _eq: $queryId } }]
      }
      order_by: [{ updated_at_block: desc }]
    ) {
      updatedAt: updated_at
      token {
        nativeId: native_id
      }
    }
    total: balance_aggregate(
      where: {
        _and: [{ token: { collection_id: { _eq: $collectionId } } }, { account: { _eq: $queryId } }]
      }
    ) {
      agg: aggregate {
        count
      }
    }
  }
`
